module.exports = __webpack_public_path__ + "static/media/fund_logo.dcbdd2da.png";